/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { PaymentsService } from '../../service/paymentsService';
import { useHistory } from 'react-router-dom';
import ShowHideLoader from '../../hooks/showHideLoader';
import { GrClose } from 'react-icons/gr';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import { GiSandsOfTime } from 'react-icons/gi';
import { AiOutlineCheck } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';

const setStyles = makeStyles((theme) => {
    const themeBackground = theme && theme.background ? theme.background : null;
    const themeTitle = theme && theme.firstTitle && theme.firstTitle.color ? theme.firstTitle.color : null;
    const themeTitleFont = theme && theme.firstTitle && theme.firstTitle.font ? theme.firstTitle.font : null;
    return {
        root: {
            width: '100vw',
            height: '100vh',
            background: themeBackground,
        },
        displayFlex: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexWrap: 'wrap',
        },
        messageContainer: {
            width: '100%',
            paddingTop: '80px',
            maxHeight: '180px',
        },
        iconContainer: {
            width: '90px',
            height: '90px',
            border: '2px solid',
            borderColor: themeTitle,
            borderRadius: '50%',
        },
        icon: {
            width: '50px',
            height: '50px',
        },
        message: {
            width: '100%',
            marginTop: '24px',
            marginBottom: '12px',
            fontFamily: themeTitleFont,
            fontSize: '24px',
            color: themeTitle,
        },
        btnContainer: {
            marginTop: '50px'
        }
    }
});

function PagoPaFeedback(props) {
    const [t] = useTranslation();
    const msgChecking = t('pagoPaFeedback.checkingPayment');
    const msgSuccess = t('pagoPaFeedback.paymentSucceded');
    const msgRefused = t('pagoPaFeedback.paymentRefused');
    const msgError = t('pagoPaFeedback.cannotCheckPayment');
    const msgPending = t('pagoPaFeedback.pendingResponse');
    const classes = setStyles();
    const history = useHistory();
    const [showLoader, hideLoader] = ShowHideLoader();
    const [message, setMessage] = useState(msgChecking);
    const [finished, setFinished] = useState(false);

    const backOrders = () => history.push('/App/Orders');


    useEffect(async () => {
        try {
            showLoader();
            const query = props.location.search;
            const session = new URLSearchParams(query).get('idSession');
            const esito = new URLSearchParams(query).get('esito');
            await PaymentsService.pagoPaCheckResult(session);
            // Nota 29/11/2021 -> Su conferma dell'helpdesk di PagoPA a volte
            // l'esito positivo arriva come "null" invece di "OK". Per sicurezza
            // viene comunque poi fatta una validazione M2M lato server.
            if (esito === 'OK' || esito === 'null') {
                switch (await PaymentsService.pagoPaWaitForPayment(session)) {
                    case PaymentsService.ORDER_PAID_STATUS.PAYING:
                        setMessage(msgPending);
                        break;
                    case PaymentsService.ORDER_PAID_STATUS.PAID_OK:
                        setMessage(msgSuccess);
                        break;
                    default:
                        setMessage(msgRefused);
                        break;
                }
            } else {
                setMessage(msgRefused);
            }
        } catch (ex) {
            console.error(ex);
            setMessage(msgError);
        } finally {
            setFinished(true);
            hideLoader();
        }
    }, []);

    return (
        <>
            <div id='pagoPaFeedback' className={classes.root}>

                <div className={classNames(classes.displayFlex, classes.messageContainer)}>
                    <div className={classNames(classes.displayFlex, classes.iconContainer)}>
                        {(message === msgChecking || message === msgPending) && (
                            <GiSandsOfTime className={classes.icon} />
                        )}

                        {message === msgSuccess && (
                            <AiOutlineCheck className={classes.icon} />
                        )}

                        {(message === msgRefused || message === msgError) && (
                            <GrClose className={classes.icon} />
                        )}

                    </div>

                    <div className={classNames(classes.displayFlex, classes.message)}>
                        {message}
                    </div>


                </div>


                {finished &&
                    <div className={classes.btnContainer}>
                        <center>
                            <input
                                type="button"
                                onClick={backOrders}
                                className={'rl-button'}
                                value={t('nexiFeedback.backToOrders')} />
                        </center>
                    </div>
                }
            </div>
        </>
    );
}

export default PagoPaFeedback;
